export const CHART_COLORS = {
  white: "#fff",
  black: "#100c06",
  "green-100": "#ebf2f0",
  "green-300": "#b4cec7",
  "green-400": "#065c45",
  "green-500": "#06382b",
  "grey-400": "#d9d9d2",
  "grey-500": "#9d9d9d",
  "grey-600": "#6d6d6d",
  "yellow-400": "#ecf86e",
  "blue-500": "#4d85f5",
} as const;
